import { createContext, useContext, useRef } from 'react';
import { SwiftFoxTableSettings } from './Membership/financial-details/contracts';
import { useTableSettings } from './Membership/query-hooks/query-implementations';
import { useContentContext } from './content-context';

type TableSettingsContext = {
	error: string | undefined;
	loading: boolean;
	getTableSettings: (tableName: string) => SwiftFoxTableSettings | undefined;
};

const Context = createContext<TableSettingsContext | undefined>(undefined);
Context.displayName = 'TableSettingsContext';

export function TableSettingsContextProvider({ children, tableNames }: { children: React.ReactNode; tableNames: string[] }) {
	const { contentId, requestToken } = useContentContext();

	const tableSettingsDataRef = useRef<SwiftFoxTableSettings[] | undefined>(undefined);

	const { error, loading } = useTableSettings({
		contentId,
		requestToken,
		skip: !tableNames.length,
		onFetchComplete: (data: SwiftFoxTableSettings[]) => {
			tableSettingsDataRef.current = data;
		}
	});

	const getTableSettings = (tableName: string) => tableSettingsDataRef?.current?.find(t => t.tableName === tableName);

	const contextValue: TableSettingsContext = {
		getTableSettings,
		error,
		loading
	};

	return <Context.Provider value={contextValue}>{children}</Context.Provider>;
}

export function useTableSettingsContext() {
	const context = useContext(Context);

	if (!context) throw new Error('Missing table settings context');

	return context;
}
